import { useCallback, useState } from "react";

import type createScoringBoardTrackingService from "app/pages/sales-intelligence/modules/lead-scoring-agent/services/tracking/scoring-board-factory";

import { useScoringRuleDeleteModalHandlers } from "./useScoringRuleDeleteModalHandlers";

type ScoringBoardTracking = ReturnType<typeof createScoringBoardTrackingService>;

const SCORING_RULE_DELETE_ERROR_PREFIX_KEY = "si.pages.score_settings.delete_modal.error";

export const useScoringBoardModalState = <TWizardState, TDeleteState>(scoringBoardTracking: ScoringBoardTracking) => {
    const [wizardState, setWizardState] = useState<TWizardState | null>(null);
    const [deleteState, setDeleteState] = useState<TDeleteState | null>(null);
    const [deleteError, setDeleteError] = useState<string | undefined>();
    const { resetDeleteState, handleDeleteCancel, confirmDeleteIfReady } = useScoringRuleDeleteModalHandlers(
        deleteState,
        setDeleteState,
        scoringBoardTracking,
    );

    const handleWizardClose = useCallback(() => setWizardState(null), []);

    const handleDeleteModalClose = useCallback(() => {
        setDeleteError(undefined);
        handleDeleteCancel();
    }, [handleDeleteCancel]);

    const clearDeleteError = useCallback(() => setDeleteError(undefined), []);

    const getDeletePersistOptions = useCallback(
        () => ({
            errorPrefixKey: SCORING_RULE_DELETE_ERROR_PREFIX_KEY,
            onErrorMessage: setDeleteError,
        }),
        [],
    );

    return {
        wizardState,
        setWizardState,
        handleWizardClose,
        deleteState,
        setDeleteState,
        deleteError,
        clearDeleteError,
        resetDeleteState,
        confirmDeleteIfReady,
        handleDeleteModalClose,
        getDeletePersistOptions,
    };
};
